import { useEffect } from "react";
import { getgiftCard } from "../store/slices/giftCardSlice";
import { useDispatch, useSelector } from "react-redux";

export const useGiftCard = () => {
  const dispatch = useDispatch();
  const giftCardData = useSelector((state) => state.giftCard);
  const tokenStatus = useSelector((state) => state.token.status);

  useEffect(() => {
    if (tokenStatus === "succeeded" && giftCardData.status === "idle") {
      dispatch(getgiftCard());
    }
  }, [tokenStatus]);

  return {
    giftCardData: giftCardData?.giftCardData,
  };
};
